import React, { Fragment } from "react";
import { Descriptor } from "./Descriptor";
import { Title } from "./Title";
export var SectionHeader = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, children = _a.children, results = _a.results, _b = _a.titleLevel, titleLevel = _b === void 0 ? "h2" : _b, tooltip = _a.tooltip;
    return (React.createElement("div", { className: "d-flex section-header align-items-baseline" },
        React.createElement(Title, { titleLevel: titleLevel },
            React.createElement(Fragment, null,
                title,
                " ",
                results && "(".concat(results, ")"),
                subtitle && React.createElement("small", null,
                    " ",
                    subtitle))),
        tooltip && (React.createElement("span", { className: "ml-2" },
            React.createElement(Descriptor, { message: tooltip, placement: "top", icon: "question-sign", color: "#757575" }))),
        children && React.createElement("div", null, children)));
};
